import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table"
import { formatDateTime } from "@/utils/format-date"
import { Calendar, FileCheck, FileX, User } from "lucide-react"
import { columns, Transaction } from "./columns"
import { DataTable } from "./data-table"

interface ScanData {
    scan: Transaction[]
    scanned_by: string
    scanned_at: string
    excelBase64: string
}

interface DtefTransactionsTableProps {
    data: ScanData | null
}

export const DtefTransactionsTable = ({ data }: DtefTransactionsTableProps) => {
    return (
        <Card className="w-full">
            <CardHeader className="pb-3">
                <div className="flex items-center justify-between flex-wrap gap-4">
                    <div className="flex items-center gap-2">
                        <FileCheck className="h-5 w-5 text-[#613F4F]" />
                        <CardTitle className="text-lg text-[#613F4F]">Detalhes das Transações</CardTitle>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                        <div className="text-sm text-muted-foreground">
                            Mostrando {data?.scan?.length || 0} transações
                        </div>
                        {data && (
                            <div className="flex flex-wrap gap-4 text-sm text-muted-foreground">
                                <div className="flex items-center gap-2">
                                    <User className="h-4 w-4" />
                                    <span>Por: {data.scanned_by}</span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <Calendar className="h-4 w-4" />
                                    <span>As: {formatDateTime(data.scanned_at)}</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                {data?.scan && data.scan.length > 0 ? (
                    <DataTable
                        columns={columns}
                        data={data.scan}
                        meta={null}
                    />
                ) : (
                    <div className="overflow-x-auto">
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={8} className="h-32 text-center">
                                        <div className="flex flex-col items-center justify-center gap-2 py-6">
                                            <FileX className="h-10 w-10 text-muted-foreground" />
                                            <p className="text-muted-foreground">
                                                Nenhuma transação carregada ainda. Por favor, faça upload de um arquivo Excel para visualizar os detalhes das transações.
                                            </p>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </div>
                )}
            </CardContent>
        </Card>
    )
}
